import React, { HTMLAttributes, useEffect, useState, useMemo, useRef } from "react";
import cx from "classnames";
import { Hooks, Context } from "@xt/xtbase";
import Smodal from "../modal";
import moment from "moment";
import * as utils from "../../utils";
const { useTranslation } = Hooks;
import { getschedule } from "@/api/xt-notice";
// import store from "store";

import styles from "./index.module.less";

const { XtContext } = Context;

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const ScheduleContent: React.FC<Props> = ({ className }) => {
  const t = useTranslation();

  const [appState] = React.useContext(XtContext);
  const { lang } = appState;

  const container = useRef(null);

  const englishMonthList = [
    t("schedule.January"),
    t("schedule.February"),
    t("schedule.March"),
    t("schedule.April"),
    t("schedule.May"),
    t("schedule.June"),
    t("schedule.July"),
    t("schedule.August"),
    t("schedule.September"),
    t("schedule.October"),
    t("schedule.November"),
    t("schedule.December"),
  ];

  const monthst = [
    {
      value: t("schedule.January"),
      key: 1,
    },
    {
      value: t("schedule.February"),
      key: 2,
    },
    {
      value: t("schedule.March"),
      key: 3,
    },
    {
      value: t("schedule.April"),
      key: 4,
    },
    {
      value: t("schedule.May"),
      key: 5,
    },
    {
      value: t("schedule.June"),
      key: 6,
    },
    {
      value: t("schedule.July"),
      key: 7,
    },
    {
      value: t("schedule.August"),
      key: 8,
    },
    {
      value: t("schedule.September"),
      key: 9,
    },
    {
      value: t("schedule.October"),
      key: 10,
    },
    {
      value: t("schedule.November"),
      key: 11,
    },
    {
      value: t("schedule.December"),
      key: 12,
    },
  ];
  const [calendarArr, setcalendarArr] = useState({
    type: "combination",
    headStyle: {
      todayBtn: "right",
      combination: "center",
      checkBtn: "right",
    },
    viewStyle: {
      day: "left",
    },
    calendarData: [],
  });

  const [showID, setshowID] = useState(0);
  const [nfOptions, setnfOptions] = useState([]);
  const [isShowModal, setisShowModal] = useState(false);
  // const calendarArrmemo = useMemo(()=> {
  //   return calendarArr.viewStyle.day
  // })

  const [headOptions, setheadOptions] = useState({
    type: calendarArr.type,
    style: calendarArr.headStyle,
    date: "",
    year: "",
  });
  const { year, month, day } = utils.getNewDate(new Date());
  const [currentMonthList, setcurrentMonthList] = useState([]);
  const [time, setTime] = useState({ year, month, day });
  const [datames, setdatames] = useState({ date: "" });

  const calendarTitleArr = [
    t("schedule.Mon"),
    t("schedule.Tues"),
    t("schedule.Wed"),
    t("schedule.Thur"),
    t("schedule.Fri"),
    t("schedule.Sat"),
    t("schedule.Sun"),
  ];

  const englishMonth = (month) => {
    let engMonth;

    englishMonthList.map(() => {
      engMonth = englishMonthList[month];
    });

    return engMonth;
  };

  const [calendatArr, setcalendatArr] = useState([]);

  const visibleCalendar: any = () => {
    let arrs = [];
    let { year, month } = utils.getNewDate(utils.getDate(time.year, time.month, 1));
    console.log(time, "ftime");
    // console.log(getschedulefun().then(res=> console.log(res)), '9999')
    let currentFirstDay: any = utils.getDate(year, month, 1);
    // 获取当前月第一天星期几
    let weekDay = currentFirstDay.getDay();
    if (weekDay === 0) {
      weekDay += 7;
    }
    let startTime = currentFirstDay - (weekDay - 1) * 24 * 60 * 60 * 1000;

    let monthDayNum;
    if (weekDay === 5 || weekDay === 6) {
      monthDayNum = 42;
    } else {
      monthDayNum = 35;
    }
    for (let i = 0; i < monthDayNum; i++) {
      const filters =
        currentMonthList.filter((ii) => {
          let getTime: any = moment(ii.time);
          const getDate = new Date(getTime).getDate();
          const getMonth = new Date(getTime).getMonth();
          const cutDate = new Date(startTime + i * 24 * 60 * 60 * 1000).getDate();
          const cutMonth = new Date(startTime + i * 24 * 60 * 60 * 1000).getMonth();
          return getDate == cutDate && getMonth == cutMonth;
        }) || [];
      arrs.push({
        date: new Date(startTime + i * 24 * 60 * 60 * 1000),
        year: year,
        month: month + 1,
        day: new Date(startTime + i * 24 * 60 * 60 * 1000).getDate(),
        clickDay: false,
        activity: [...filters],
      });
    }
    const newheadOptions = { ...headOptions, date: `${englishMonth(month)}`, year: `${year}` };
    setheadOptions({ ...newheadOptions });
    console.log(headOptions, calendatArr, "calendatArr");
    setcalendatArr([...arrs]);
  };

  // 是否是当月
  const isCurrentMonth = (date) => {
    let { year: currentYear, month: currentMonth } = utils.getNewDate(utils.getDate(time.year, time.month, 1));
    let { year, month } = utils.getNewDate(date);
    return currentYear === year && currentMonth === month;
  };

  // 是否是今天
  const isCurrentDay = (date) => {
    let { year: currentYear, month: currentMonth, day: currentDay } = utils.getNewDate(new Date());
    let { year, month, day } = utils.getNewDate(date);
    return currentYear === year && currentMonth === month && currentDay === day;
  };

  const handleClickDay = (item: any) => {
    setdatames(item);
    if (item && item.activity && item.activity.length) {
      setisShowModal(true);
    }
  };

  const confirmTime = (payload: any) => {
    if (payload) {
      let now = new Date(moment(payload.timeMs).valueOf()).getHours();
      let nowmin = new Date(moment(payload.timeMs).valueOf()).getMinutes();
      return now + ":" + (nowmin > 9 ? nowmin : "0" + nowmin);
    }
    return "";
  };

  const getschedulefun = () => {
    setcurrentMonthList([]);
    let { year, month } = utils.getNewDate(utils.getDate(time.year, time.month, 1));
    getschedule({
      time: year + "-" + (month + 1 > 9 ? month + 1 : "0" + (month + 1)),
      lang,
    }).then((res) => {
      const result =
        res.map((ii) => {
          return {
            ...ii,
            time: moment(ii.timeMs).format("YYYY-MM-DD HH:MM:ss"),
          };
        }) || [];
      console.log(result, "result");
      setcurrentMonthList([...result]);
    });

    // visibleCalendar()
  };

  // 上一个月
  const handlePrevMonth = () => {
    let prevMonth = utils.getDate(time.year, time.month, 1);
    console.log(prevMonth, "prevmonth");
    prevMonth.setMonth(prevMonth.getMonth() - 1);
    console.log(prevMonth, "prevmonth");
    const netime = utils.getNewDate(prevMonth);
    console.log(netime, "netime");
    setTime({ ...netime });
    const newheadOptions = { ...headOptions, date: `${englishMonth(time.month)}`, year: `${time.year}` };
    setheadOptions({ ...newheadOptions });
    // getschedulefun();
  };

  // 下一个月
  const handleNextMonth = () => {
    let nextMonth = utils.getDate(time.year, time.month, 1);
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    setTime({ ...utils.getNewDate(nextMonth) });
    const newheadOptions = { ...headOptions, date: `${englishMonth(time.month)}`, year: `${time.year}` };
    setheadOptions({ ...newheadOptions });
    // getschedulefun();
  };

  //点击具体到某个月
  const setmonth = (item) => {
    let thisMonth = utils.getDate(time.year, time.month, 1);
    thisMonth.setMonth(item.key - 1);
    setTime({ ...utils.getNewDate(thisMonth) });
    const newheadOptions = { ...headOptions, date: `${englishMonth(time.month)}`, year: `${time.year}` };
    setheadOptions({ ...newheadOptions });
    // getschedulefun();
    setshowID(0);
  };
  //点击具体到某年
  const setyears = (item) => {
    let thisyears = utils.getDate(time.year, time.month, 1);
    thisyears.setFullYear(item.dictValue);
    setTime({ ...utils.getNewDate(thisyears) });
    const newheadOptions = { ...headOptions, year: `${time.year}` };
    setheadOptions({ ...newheadOptions });
    // getschedulefun();
    setshowID(0);
  };

  // 上一年
  const handlePrevYear = () => {
    let prevyear = utils.getDate(time.year, time.month, 1);
    prevyear.setFullYear(prevyear.getFullYear() - 1);
    setTime({ ...utils.getNewDate(prevyear) });
    const newheadOptions = { ...headOptions, year: `${time.year}` };
    setheadOptions({ ...newheadOptions });
    // getschedulefun();
  };
  // 下一年
  const handleNextYear = () => {
    let prevYear = utils.getDate(time.year, time.month, 1);
    prevYear.setFullYear(prevYear.getFullYear() + 1);
    setTime({ ...utils.getNewDate(prevYear) });
    const newheadOptions = { ...headOptions, year: `${time.year}` };
    setheadOptions({ ...newheadOptions });
    // getschedulefun();
  };

  // 点击回到今天
  const handleToday = () => {
    setTime({ ...utils.getNewDate(new Date()) });
    // returnDate();
  };

  const today = useMemo(() => {
    let todays = new Date(datames?.date);
    console.log(todays, "todays");
    return todays.getFullYear() + "/" + (todays.getMonth() + 1) + "/" + todays.getDate();
  }, [datames]);

  const currenttoday = useMemo(() => {
    let todays = new Date();
    return todays.getFullYear() + "/" + (todays.getMonth() + 1) + "/" + todays.getDate();
  }, []);

  const todata = useMemo(() => {
    let now = new Date(datames.date);
    let day = now.getDay();
    let weeks = new Array(
      t("schedule.Sunday"),
      t("schedule.Monday"),
      t("schedule.Tuesday"),
      t("schedule.Wednesday"),
      t("schedule.Thursday"),
      t("schedule.Friday"),
      t("schedule.Saturday")
    );
    let week = weeks[day];
    return week;
  }, [datames]);

  const currenttodata = useMemo(() => {
    let now = new Date();
    let day = now.getDay();
    let weeks = new Array(
      t("schedule.Sunday"),
      t("schedule.Monday"),
      t("schedule.Tuesday"),
      t("schedule.Wednesday"),
      t("schedule.Thursday"),
      t("schedule.Friday"),
      t("schedule.Saturday")
    );
    let week = weeks[day];
    return week;
  }, []);

  const changemonth = () => {
    if (showID === 1) {
      setshowID(0);
    } else {
      setshowID(1);
    }
  };

  const changeyear = () => {
    if (showID === 2) {
      setshowID(0);
    } else {
      setshowID(2);
    }
  };

  const getNf = () => {
    let nfOptionsArray = new Array();
    let years = new Date().getFullYear();
    for (let i = years - 10; i <= years + 10; i++) {
      let anOption = {
        dictValue: undefined,
        dictLabel: undefined,
      };
      anOption.dictValue = i;
      anOption.dictLabel = i;
      nfOptionsArray.push(anOption);
    }
    setnfOptions(nfOptionsArray);
  };

  const onClose = () => {
    setisShowModal(false);
  };

  const otherClose = (e) => {
    console.log(e);
    if (!container.current.contains(e.target)) setshowID(0);
  };

  useEffect(() => {
    getNf();
    window.addEventListener("click", otherClose);
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("click", otherClose);
    };
  }, []);
  useEffect(() => {
    getschedulefun();
    visibleCalendar();
  }, [time]);

  useEffect(() => {
    visibleCalendar();
  }, [currentMonthList]);
  // const {isLogin} = store.user;

  const content = () => {
    return (
      <div className={cx(`${styles.scheduleContents}`, className)}>
        <ul className={cx(`${styles.scheduleWeek}`, className)}>
          {calendarTitleArr.map((ii, index) => {
            return (
              <li key={index} className={cx(`${styles.scheduleWeekLi}`, className)}>
                {ii}
              </li>
            );
          })}
        </ul>
        <ul className={cx(`${styles.scheduleView}`, className)}>
          {calendatArr &&
            calendatArr.length &&
            calendatArr.map((ii, index) => {
              return (
                <li
                  className={cx(
                    `${styles.scheduleViewLi} ${!isCurrentMonth(ii.date) && styles.monthClass} ${isCurrentDay(ii.date) && styles.todayBg}`,
                    className
                  )}
                  onClick={() => handleClickDay(ii)}
                >
                  <span className={cx(`${styles.dataDay} ${!isCurrentMonth(ii.date) && styles.opacityClass}`, className)}>
                    <span className={cx(`${styles.todayCircle}`, className)}>{ii.day}</span>
                    {ii.activity && !!ii.activity.length && <span className={cx(`${styles.arrowR}`, className)}> &gt;</span>}
                  </span>
                  <div className={cx(`${styles.listT}`, className)}>
                    {(ii.activity && ii.activity.length > 4 ? ii.activity.slice(0, 4) : ii.activity).map((tt, it) => {
                      return (
                        <p
                          key={it}
                          className={cx(
                            `${new Date(ii.date).getTime() < new Date(new Date().toDateString()).getTime() ? styles.aexporeeclass : styles.aclass}`,
                            className
                          )}
                        >
                          {confirmTime(tt)} {tt.name}
                        </p>
                      );
                    })}
                  </div>
                </li>
              );
            })}
        </ul>
      </div>
    );
  };

  return (
    <div className={cx(`${styles.scheduleContent}`, className)}>
      <div className={cx(`${styles.scheduleContentHeader}`, className)}>
        <div className={cx(`${styles.scalend}`, className)}>
          <div className={cx(`${styles.scalendleft}`, className)}>
            <div className={cx(`${styles.scalendIcon}`, className)}>
              <img src={require("@/assets/images/common/schedule_icons.png").default} />
            </div>
            <div className={cx(`${styles.sign}`, className)}>
              <p className={cx(`${styles.today}`, className)}>{t("schedule.Today")}</p>
              <p className={cx(`${styles.todayTime}`, className)}>
                {currenttoday} ({currenttodata})
              </p>
            </div>
          </div>
          <div className={cx(`${styles.scalendright}`, className)} ref={container}>
            <div className={cx(`${styles.scontent}`, className)}>
              <div className={cx(`${styles.months}`, className)}>
                <span
                  className={cx(`${styles.swordL}`, className)}
                  onClick={handlePrevMonth}
                  style={{ backgroundImage: `url(${require("@/assets/images/common/schedule_arrow.png").default})` }}
                ></span>
                <span className={cx(`${styles.swordcon}`, className)}>
                  <span onClick={changemonth}>{headOptions.date}</span>
                  {showID && showID == 1 ? (
                    <div className={cx(`${styles.monthListSel}`, className)}>
                      {monthst &&
                        monthst.map((nn) => {
                          return (
                            <div onClick={() => setmonth(nn)} key={nn.key} className={cx(`${styles.monthListSelChi}`, className)}>
                              {nn.value}
                            </div>
                          );
                        })}
                    </div>
                  ) : null}
                </span>
                <span
                  className={cx(`${styles.swordr}`, className)}
                  onClick={handleNextMonth}
                  style={{ backgroundImage: `url(${require("@/assets/images/common/schedule_arrow.png").default})` }}
                ></span>
              </div>
              <div className={cx(`${styles.year}`, className)}>
                <span
                  className={cx(`${styles.swordL}`, className)}
                  onClick={handlePrevYear}
                  style={{ backgroundImage: `url(${require("@/assets/images/common/schedule_arrow.png").default})` }}
                ></span>
                <span className={cx(`${styles.swordcon}`, className)}>
                  <span onClick={changeyear}>{headOptions.year}</span>
                  {showID && showID == 2 ? (
                    <div className={cx(`${styles.monthListSel}`, className)}>
                      {nfOptions &&
                        nfOptions.map((nn) => {
                          return (
                            <div onClick={() => setyears(nn)} key={nn.dictValue} className={cx(`${styles.monthListSelChi}`, className)}>
                              {nn.dictLabel}
                            </div>
                          );
                        })}
                    </div>
                  ) : null}
                </span>
                <span
                  className={cx(`${styles.swordr}`, className)}
                  onClick={handleNextYear}
                  style={{ backgroundImage: `url(${require("@/assets/images/common/schedule_arrow.png").default})` }}
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {content()}
      <Smodal isShowModal={isShowModal} datames={datames} onClose={onClose} title={`${today} (${todata})`} />
    </div>
  );
};

export default ScheduleContent;
